import Icon from "@mui/material/Icon";
import {
  MdSpaceDashboard,
  MdBusinessCenter,
  MdArticle,
  MdEventRepeat,
  MdAccountBalanceWallet,
  MdReceiptLong,
  MdAssessment,
  MdPeopleAlt,
  MdCorporateFare,
  MdHome,
  MdWorkOutline,
  MdTaskAlt,
  MdAdminPanelSettings,
  MdOutlineDesk,
  MdPayment,
  MdSecurity,
  MdMiscellaneousServices,
  MdOutlineHowToReg,
  MdOutlineAccountBalance,
  MdOutlineRequestQuote,
  MdAnalytics,
  MdFactCheck,
  MdOutlineSettings,
  MdPerson,
  MdPostAdd,
} from "react-icons/md";
import { RiGovernmentLine } from "react-icons/ri";
import { FiCheckSquare } from "react-icons/fi";

const moduleIcons = {
  Dashboard: <MdSpaceDashboard />,
  "Business Masters": <MdBusinessCenter />,
  "Business Forms": <MdArticle />,
  "Month End": <MdEventRepeat />,
  "Account Masters": <MdAccountBalanceWallet />,
  Vouchers: <MdReceiptLong />,
  "Business Reports": <MdAssessment />,
  Reports: <MdAssessment />,
  HRMS: <MdPeopleAlt />,
  "Head Office": <RiGovernmentLine />,
  "Home Page": <MdHome />,
  EmployeeLetterDesk: <MdWorkOutline />,
  Approvals: <FiCheckSquare />,
  Admin: <MdAdminPanelSettings />,
  "My Desk": <MdOutlineDesk />,
  "Invoice Management": <MdOutlineRequestQuote />,
  "Payment Processing": <MdPayment />,
  MIS: <MdMiscellaneousServices />,
  "Company Setup": <MdOutlineSettings />,
  Access: <MdSecurity />,
  "Provider & DSA Operations": <MdCorporateFare />,
  "Pre Joining": <MdOutlineHowToReg />,
  "Payroll Management": <MdOutlineAccountBalance />,
  Profiles: <MdPerson />,
  Invoices: <MdOutlineRequestQuote />,
  Operation: <MdTaskAlt />,
  Analytics: <MdAnalytics />,
  "Data Setup": <MdPostAdd />,
  "Post Joining": <MdOutlineHowToReg />,
  Payroll: <MdOutlineAccountBalance />,
  "Review & Approvals": <MdFactCheck />,
  "Profit and Loss Report": <MdAssessment />,
};

// Builds the sidebar/route tree for a single module (e.g. after clicking a
// landing-page tile). Kept separate from transformMenuData because this API
// response uses different field names (routingPath vs eouRoutingPath) and a
// name-keyed icon set instead of an icon-name-per-item. Regenerated fresh
// (not deserialized) whenever the session is rehydrated after a refresh,
// since icon elements can't survive a JSON round-trip.
export function transformModuleMenuData(data) {
  const result = [];
  const groupedMap = new Map();

  (data || []).forEach((item) => {
    const { mainMenuId, mainMenu, subMenuId, subMenuName, routingPath, type, icon, component } =
      item;
    if (!groupedMap.has(mainMenuId))
      groupedMap.set(mainMenuId, { mainMenuId, mainMenu, children: [] });
    groupedMap.get(mainMenuId).children.push({
      subMenuId,
      subMenuName,
      routingPath,
      type,
      menuKey: subMenuName.toLowerCase().replace(/\s+/g, "-"),
      icon,
      component,
    });
  });

  groupedMap.forEach((group) => {
    if (group.children.length === 1) {
      const child = group.children[0];
      result.push({
        type: "collapse",
        name: group.mainMenu,
        key: child.menuKey,
        route: child.routingPath,
        icon: <Icon fontSize="small">{child.icon}</Icon>,
        component: child.component,
      });
    } else {
      result.push({
        type: "dropdown",
        name: group.mainMenu,
        key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
        icon: moduleIcons[group.mainMenu],
        collapse: [
          {
            type: "collapse",
            name: "",
            key: "",
            collapse: group.children.map((child) => ({
              type: "collapse",
              name: child.subMenuName,
              key: child.menuKey,
              route: child.routingPath,
              icon: <Icon fontSize="small">{child.icon}</Icon>,
              component: child.component,
            })),
          },
        ],
      });
    }
  });

  return result;
}
